import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Button, Grid, TextareaAutosize, Tooltip } from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import sendIconWhite from "../../../src/assets/images/UrgentMessages/sendIconWhite.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  createUrgentMessage,
  listUrgentMessages,
} from "../../slices/UrgentMessages/UrgentMessagesSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";

function EmergencyMessage() {
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const { darkMode } = useContext(ThemeContext);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [rowsPerPage, setRowsPerPage] = useState(50)
  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });
  const { t } = useTranslation();
  const [message, setMessage] = useState({
    message: "",
  });
  const [date, setDate] = useState("");

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size)
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  const handleTextChange = (event) => {
    const name = event.target.name;
    setMessage({
      ...message,
      [name]: event.target.value,
    });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 20) {
      return text.substring(0, 30) + "...";
    } else {
      return text;
    }
  };

  useEffect(() => {
    loadData(paging);
  }, [paging]);

  const loadData = (paging) => {
    const filter = {
      page: paging.page,
      rowsPerPage: paging.rowsPerPage,
    };
    dispatch(listUrgentMessages(filter))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000" && data.data) {
          setRows(data.data.urgentMessages);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
          setTotalRecords(data.data.totalCount);
        }
      })
      .catch((er) => { });
  };

  const createMessage = () => {
    if (CommonUtil.isEmptyString(message.message)) {
      Toast(t("ENTER_EMERGENCY"), "error");
      return;
    }
    dispatch(createUrgentMessage(message))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0077" && data.data) {
          setMessage({ ...message, message: "" });
          Toast(data.message, "success");
          loadData(paging);
        } else Toast(data.message, "error");
      })
      .catch((er) => { });
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const renderCellCreatedAt = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.createdAt)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
          ? "MM-DD-YYYY HH:mm"
          : date === "yyyy-MM-dd HH:mm"
            ? "YYYY-MM-DD HH:mm"
            : ""
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const columns = React.useMemo(
    () => [
      {
        headerName: "",
        sortable: false,
        width: 5,
        renderCell: (params) => {
          return <div></div>;
        },
      },
      {
        field: "message",
        headerName: t("commonsPathMessage"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.message,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },
      {
        field: "Created By",
        headerName: t("URGENTMESS0003"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.createdByName,
      },

      {
        field: "Created Time",
        headerName: t("URGENTMESS0007"),
        flex: 1,
        width: 10,
        renderCell: renderCellCreatedAt(formatDate(companySettings.dateFormat)),
      },
    ],
    [date]
  );

  return (
    <div>
      <HeaderToolbar
        src={""}
        onClick={""}
        title={t("URGENTMESS0004")}
        tooltipTitle=""
      />

      <Grid
        container
        style={{
          display: "flex",
          marginTop: "15px",
          marginBottom: "15px",
        }}
      >
        <Grid item xs={11}>
          <TextareaAutosize
            minRows={3}
            maxLength="300"
            placeholder={t("URGENTMESS0005")}
            name="message"
            value={message.message}
            onChange={handleTextChange}
            style={{
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
              color: darkMode ? "#fff" : "",
              borderColor: "#949596",
              resize: "none",
              width: "90%",
              borderRadius: "8px",
            }}
          />
        </Grid>
        <Grid
          item
          xs={1}
          alignSelf="flex-end"
          float="left"
          writingMode="vertical-rl"
          bottom="7px"
        >
          <Box display="flex" justifyContent="flex-end">
            <Tooltip title={t("tableToolTipSendMessage")} arrow>
              <Button
                variant="contained"
                size="small"
                onClick={createMessage}
                style={{
                  backgroundColor: "#E3393C",
                }}
              >
                <img alt="SendIcon" src={sendIconWhite} />
              </Button>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        gap="5px"
      >
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(paging)} />
          </Box>
        </Tooltip>
      </Box>

      <div style={{ height: 300, width: "100%"}}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          emergencyMsg={true}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
    </div>
  );
}

export default EmergencyMessage;
